import { createContext } from 'react';
import type { Questionnaire } from '@/typings/Questionnaire';
import * as QuestionnaireApiModels from '@/typings/questionnaires-api-models';
import _ from 'lodash';
import checkFieldValidity from '@helpers/questionnaires/checkFieldValidity';
import { Creditor } from '@/typings/api-models';
import { AiAgent } from './useLoadAiAgents';

export type QuestionnaireContextType = {
  aiAgents: AiAgent[] | null;
  aiAgentsReadyToRun: boolean;
  checkFieldValidity: typeof checkFieldValidity;
  currentSection: string;
  defaultValues: Record<string, unknown>;
  referenceData: QuestionnaireApiModels.DataReference[];
  setCurrentSection: (sectionId: string) => void;
  getSectionProgress: (sectionId: string, fieldsVisibility: Record<string, boolean>) => number;
  sectionVisibility: Record<string, boolean>;
  setSectionVisibility: (sectionId: string, isVisible: boolean) => void;
  isEnabled: boolean;
  setIsEnabled: (isEnabled: boolean) => void;
  setReferenceData: (data: QuestionnaireApiModels.DataReference[]) => void;
  getSubsectionProgress: (
    sectionId: string,
    subsection: string,
    fieldsVisibility: Record<string, boolean>,
  ) => {
    completedFields: number;
    subsectionProgressPercentage: number | null;
    totalFields: number;
  } | null;
  sectionErrors: { [key: string]: boolean };
  setSectionErrors: (errors: { [key: string]: boolean }) => void;
  onSubmit: (responses: QuestionnaireApiModels.UpdateResponseData, isCompleted?: boolean) => Promise<boolean>;
  aiAutofillActions: string[];
  fieldsByKey: Record<string, Questionnaire.Field>;
  fieldsById: Record<string, Questionnaire.Field>;
  formData: Questionnaire.Questionnaire;
  userWorkflowId: string | null;
  questionnaireId: string;
  questionnaireResponses: Array<
    & Pick<QuestionnaireApiModels.QuestionnaireResponse, 'id' | 'value' | 'source' | 'associatedWithId' | 'aiRequestId' | 'hasAutofillRun' | 'explanationHtml'>
    & {
      listResponses: Array<
        & Pick<QuestionnaireApiModels.QuestionnaireResponse, 'value' | 'index' | 'source' | 'aiRequestId' | 'hasAutofillRun' | 'explanationHtml'>
        & {
          fieldTemplate: Pick<QuestionnaireApiModels.FieldTemplate, 'key'>;
        }
      > | null;
      fieldTemplate: Pick<QuestionnaireApiModels.FieldTemplate, 'type' | 'key'>;
    }
  >
  refetchCreditors: () => void;
  creditors: Creditor[];
};

const QuestionnaireContext = createContext<QuestionnaireContextType | undefined>(undefined);

export default QuestionnaireContext;
